import { useCallback } from 'react'
import { getMessage } from 'utility/MapperResponse'
import { showAlert } from 'utility/SweetAlert'
import ApiService from 'services/ApiService'

const InteractorMasterSubdistrictView = () => {
  const subdistrictView = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/management/master-subdistrict/view', payload, (response) => {
      if (response.code === 7200) {
        callback(response.data)
      } else {
        showAlert({
          icon: 'error',
          message: getMessage(response?.msg),
          timer: 2000,
          back: true,
        })
      }
      loading(false)
    })
  }, [])

  return { subdistrictView }
}

export default InteractorMasterSubdistrictView
